var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es163.js.map
